import WarehouseIcon from '@mui/icons-material/Warehouse';
import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { ReactNode } from 'react';

import SelectField from '@/components/SelectField';

interface WarehouseOption {
  value: string;
  label: string;
}

interface WarehouseSelectorProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  infoText?: string;
  options: WarehouseOption[];
  isLoading?: boolean;
  title?: ReactNode;
}

const WarehouseSelector = ({
  label,
  value,
  onChange,
  error,
  placeholder = 'Seleccione un almacén',
  infoText,
  options,
  isLoading = false,
  title,
}: WarehouseSelectorProps) => {
  const theme = useTheme();

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(event.target.value);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 0.5,
        border: '1px solid',
        borderColor: theme.palette.grey[300],
        borderRadius: '1rem',
        p: 1.5,
        mt: 2,
      }}
    >
      {title && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
          <Typography variant="body2" fontWeight="bold">
            {title}
          </Typography>
        </Box>
      )}

      <SelectField
        label={label}
        name="warehouse"
        options={isLoading ? [{ value: '', label: 'Cargando...' }] : options}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        icon={<WarehouseIcon />}
        errors={error ? { warehouse: { message: error } } : undefined}
        sxLabel={{ margin: '0.5rem 0.5rem 0.25rem 0', fontSize: '0.875rem' }}
        sxSelect={{
          '& .MuiSelect-select': {
            padding: '8px 14px',
            fontSize: '0.875rem',
          },
        }}
      />

      {infoText && (
        <Typography variant="caption" color={theme.palette.grey[600]} sx={{ mt: 0.5 }}>
          {infoText}
        </Typography>
      )}
    </Box>
  );
};

export default WarehouseSelector;
